/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Import_FileInputs */

const en_shortcut_keys_name_import_file = /** @type {(inputs: Shortcut_Keys_Name_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import File`)
};

const fr_shortcut_keys_name_import_file = /** @type {(inputs: Shortcut_Keys_Name_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer un fichier`)
};

const de_shortcut_keys_name_import_file = /** @type {(inputs: Shortcut_Keys_Name_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importdatei`)
};

const it_shortcut_keys_name_import_file = /** @type {(inputs: Shortcut_Keys_Name_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa file`)
};

const ru_shortcut_keys_name_import_file = /** @type {(inputs: Shortcut_Keys_Name_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт файла`)
};

const es_shortcut_keys_name_import_file = /** @type {(inputs: Shortcut_Keys_Name_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar archivo`)
};

const zh_cn2_shortcut_keys_name_import_file = /** @type {(inputs: Shortcut_Keys_Name_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入文件`)
};

const ja_shortcut_keys_name_import_file = /** @type {(inputs: Shortcut_Keys_Name_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルのインポート`)
};

const hi_shortcut_keys_name_import_file = /** @type {(inputs: Shortcut_Keys_Name_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात फ़ाइल`)
};

const pt_pt2_shortcut_keys_name_import_file = /** @type {(inputs: Shortcut_Keys_Name_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo de importação`)
};

/**
* | output |
* | --- |
* | "Import File" |
*
* @param {Shortcut_Keys_Name_Import_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_import_file = /** @type {((inputs?: Shortcut_Keys_Name_Import_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Import_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_import_file(inputs)
	if (locale === "de") return de_shortcut_keys_name_import_file(inputs)
	if (locale === "it") return it_shortcut_keys_name_import_file(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_import_file(inputs)
	if (locale === "es") return es_shortcut_keys_name_import_file(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_import_file(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_import_file(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_import_file(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_import_file(inputs)
	return en_shortcut_keys_name_import_file(inputs)
});